// Copyright 2023, Durable
import React from "react";
import { ViewUser } from "@durable/durable-client";
import { Avatar, Tooltip } from "@mui/material";

/**
 * Get whatever string is available from a user.
 *
 * @param user ViewUser to scrape a display string from.
 */
function getDisplayString(user: ViewUser) {
  const userDisplayBase =
    user.display_name ??
    user.username ??
    user.email ??
    user.username ??
    "N/A";

  return userDisplayBase;
}

/**
 * Component that displays an icon for a user.
 *
 * This will use the user profile picture if available, and an abbreviation
 * of the rendered user string if not.
 *
 * @param user: User to render an icon for.
 * @param onClick: Any function that should be called on the user icon click.
 * @param selected: If this user is selected.
 */
export function IconForUser({
  user,
  onClick,
  className
}: {
  user: ViewUser;
  onClick?: () => void;
  className?: string;
}) {
  const userDisplayString = getDisplayString(user);

  return (
    <Tooltip title={userDisplayString}>
      <Avatar
        alt={userDisplayString}
        className={`cursor-pointer bg-durableTealDark-300 text-coolGrey-1000 
        ${className}`}
        src={user.profile_picture_url}
        onClick={onClick}
      >
        {user.profile_picture_url ??
          userDisplayString.slice(0, 1).toLocaleUpperCase()}
      </Avatar>
    </Tooltip>
  );
}
